import React from "react";

function formatTime(totalSeconds) {
  const m = Math.floor(totalSeconds / 60);
  const s = Math.floor(totalSeconds % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

export default function TrackPlayer({ track, isPlaying, currentTime, onToggle, onSeek }) {
  const progress = currentTime / track.durationSeconds;
  const playedBars = Math.round(progress * track.waveform.length);

  const handleSeek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
    onSeek(Math.round(ratio * track.durationSeconds));
  };

  return (
    <div className="track-player">
      <button
        type="button"
        className="track-player-toggle"
        onClick={onToggle}
        aria-label={isPlaying ? "Pause" : "Play"}
      >
        {isPlaying ? (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M4 3.5h2.5v9H4v-9Zm5.5 0H12v9H9.5v-9Z" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M4.5 3.2a.6.6 0 0 1 .92-.51l7.5 4.8a.6.6 0 0 1 0 1.02l-7.5 4.8a.6.6 0 0 1-.92-.51V3.2Z" />
          </svg>
        )}
      </button>

      <div className="track-player-time">{formatTime(currentTime)}</div>

      <div className="track-player-waveform" onClick={handleSeek}>
        {track.waveform.map((h, i) => (
          <span
            key={i}
            className={`wave-bar ${i < playedBars ? "played" : ""}`}
            style={{ height: `${h * 100}%` }}
          ></span>
        ))}
      </div>

      <div className="track-player-time">{track.duration}</div>

      <div className="track-player-share">
        <a href="#facebook" aria-label="Share on Facebook">
          <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951Z" />
          </svg>
        </a>
        <a href="#twitter" aria-label="Share on X">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.6.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
          </svg>
        </a>
        <a href="#instagram" aria-label="Share on Instagram">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708C16 15.487 15.474 16 14.825 16H1.175A1.15 1.15 0 0 1 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
          </svg>
        </a>
      </div>
    </div>
  );
}
